/* unplugin-vue-components disabled */import { render } from "./DownloadTop.vue?vue&type=template&id=09aa468a"
import script from "./DownloadTop.vue?vue&type=script&lang=js"
export * from "./DownloadTop.vue?vue&type=script&lang=js"

import "./DownloadTop.vue?vue&type=style&index=0&id=09aa468a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__